import request from '@/utils/request';

/**
 * Care Bot健康助手 接口
 */
export const careBotApi = {
    // 历史会话
    async chatHistory() {
        const rsp = await request({
            url: '/chat/chat-list?include_func_types=none_type',
            method: 'get',
        });
        console.log('chatHistory', { rsp });
        return rsp;
    },

    /** 删除历史会话 */
    deleteChatById(data) {
        return request({
            url: '/chat/chat-delete',
            method: 'post',
            data,
        });
    },

    // 回答评分
    async chatMsgScore(chat_id, msg_id, score) {
        return request({
            url: `/chat/${chat_id}/msg-list/${msg_id}`,
            method: 'post',
            data: {
                msg_score: score,
            },
        });
    },

    // 用户注册
    userRegister(data) {
        return request({
            url: '/user/register',
            method: 'post',
            data,
        });
    },

    // 忘记密码——获取验证码
    getValidateCode(data) {
        return request({
            url: '/user/require_reset_code',
            method: 'post',
            data,
        });
    },

    // 忘记密码——重置密码
    resetPassword(data) {
        return request({
            url: '/user/reset_password',
            method: 'post',
            data,
        });
    },
};



// WEBPACK FOOTER //
// ./src/api/carebot.js